/**
 * Duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/isExternalLink.ts
 */
export const isExternalLink = (url?: string): boolean => {
	if (!url) {
		return false;
	}

	try {
		const urlObj = new URL(url, window.location.origin);
		return urlObj.origin !== window.location.origin;
	} catch {
		return false;
	}
};
